import { ObjectUtils } from 'primereact/utils';

// ============================================================================
// TÌM KIẾM KHÔNG DẤU TIẾNG VIỆT CHO BỘ LỌC CỦA PRIMEREACT
//
// Vấn đề: PrimeReact tự bỏ dấu trước khi so khớp, nhưng hàm ObjectUtils.removeAccents
// của nó CHỈ xử lý dải Latin-1 (\xC0-\xFF) — vốn dành cho tiếng Pháp/Đức. Phần lớn ký
// tự tiếng Việt nằm NGOÀI dải đó nên không được bỏ dấu:
//   'ĐƠN HÀNG'          -> 'đơn hang'          => gõ 'don hang' KHÔNG ra
//   'NGUYỄN VĂN A'      -> 'nguyễn văn a'      => gõ 'nguyen van a' KHÔNG ra
//   'QUẢN TRỊ HỆ THỐNG' -> 'quản trị hệ thống' => gõ 'quan tri' KHÔNG ra
//
// FilterService (primereact/api) gọi ObjectUtils.removeAccents cho CẢ chuỗi người dùng
// gõ lẫn giá trị từng option, nên một lần vá là mọi bộ lọc dùng chung: MultiSelect,
// Dropdown, AutoComplete, ListBox, DataTable filter...
// ============================================================================

/**
 * Bỏ dấu tiếng Việt.
 *
 * Dùng NFD để tách ký tự gốc khỏi dấu rồi xóa toàn bộ dấu tổ hợp (U+0300–U+036F) —
 * phủ hết dấu thanh (huyền/sắc/hỏi/ngã/nặng) lẫn dấu phụ (mũ ˆ, trăng ˘, móc ̛ của
 * ơ/ư). Riêng đ/Đ là CHỮ CÁI riêng, không tách được bằng NFD nên xử lý tay.
 *
 * Chỉ bỏ dấu, KHÔNG đụng tới dấu câu hay khoảng trắng để không phá việc lọc theo mã.
 */
export const removeViAccents = (str: any): any => {
  if (typeof str !== 'string' || str.length === 0) {
    return str;
  }
  return str
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'D')
    .normalize('NFC');
};

/**
 * Vá ObjectUtils.removeAccents của PrimeReact. Gọi MỘT LẦN lúc khởi động app,
 * TRƯỚC khi render (xem index.tsx).
 */
export function patchPrimeReactViFilter(): void {
  const target = ObjectUtils as any;
  if (!target || target.__viAccentsPatched) {
    return;
  }
  target.removeAccents = removeViAccents;
  target.__viAccentsPatched = true;
}
